import rewards from '@/api/reseller-rewards';

// reseller rewards
const APPEND_NEW_REWARD = 'APPEND_NEW_REWARD';
// const APPEND_TIERS = 'APPEND_TIERS';
const SET_REWARDS = 'SET_REWARDS';
const RESET_RESELLER_REWARDS = 'RESET_RESELLER_REWARDS';
const DELETE_RESELLER_REWARDS = 'DELETE_RESELLER_REWARDS';
const UPDATED_RESELLER_REWARD_DATA = 'UPDATED_RESELLER_REWARD_DATA';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_PAGE = 'SET_PAGE';
const ADD_PAGE = 'ADD_PAGE';
const SET_IS_ALL = 'SET_IS_ALL';

const state = {
	all: [],
	isFetching: false,
	isFetched: false,
	isAll: false,
	page: 1,
	detail: '',
};

const getters = {
	all: state => state.all,
	isFetching: state => state.isFetching,
	isFetched: state => state.isFetched,
	isAll: state => state.isAll,
	page: state => state.page,
	detail: state => state.detail,
};

const mutations = {
	[UPDATED_RESELLER_REWARD_DATA](state, reward) {
		const rewardIndex = state.all.findIndex(curr => curr._id === reward._id);
		if (rewardIndex !== -1) {
			state.all[rewardIndex].name = reward.name;
			state.all[rewardIndex].type = reward.type;
			state.all[rewardIndex].point = reward.point;
			state.all[rewardIndex].icon = reward.icon;
			state.all[rewardIndex].status = reward.status;
			state.all[rewardIndex].description = reward.description;
		}
	},
	[APPEND_NEW_REWARD](state, reward) {
		const rewards = state.all;
		rewards.unshift(reward);
		state.all = rewards;
	},
	[SET_REWARDS](state, rewards) {
		state.all = rewards;
	},
	[RESET_RESELLER_REWARDS](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[DELETE_RESELLER_REWARDS](state, index) {
		state.all.splice(index, 1);
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[SET_PAGE](state, page) {
		state.page = page;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
	[SET_IS_ALL](state, isAll) {
		state.isAll = isAll;
	},
};

const actions = {
	// cutomers
	updatedResellerRewardData({ commit }, value) {
		commit(UPDATED_RESELLER_REWARD_DATA, value);
	},
	getResellerRewards({ commit, getters }, params) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const rewards = response.data;

				if (getters.all.length === 0) {
					commit(SET_REWARDS, rewards);
				} else if (rewards.length !== 0) {
					commit(APPEND_NEW_REWARD, rewards);
				}

				if (rewards.length === 0) {
					commit(SET_IS_ALL, true);
				} else {
					commit(SET_IS_ALL, false);
				}

				commit(ADD_PAGE);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_ALL, true);
				commit(SET_IS_FETCHED, true);
			};
			rewards.index(params, callback, errorCallback);
		}
	},
	resetResellerRewards({ commit }) {
		commit(RESET_RESELLER_REWARDS);
	},
	setPage({ commit }, value) {
		commit(SET_PAGE, value);
	},
	setIsAll({ commit }, isAll) {
		commit(SET_IS_ALL, isAll);
	},
	setAppendNewReward({ commit }, value) {
		commit(APPEND_NEW_REWARD, value);
	},
	delete({ commit }, index) {
		commit(DELETE_RESELLER_REWARDS, index);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
